import store from "@/store";
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: ()=>import('../views/ManageTeacher.vue'),
    redirect:"/login",
    children:[
      // { path: 'course', name: '课程', component: () => import('../views/Course.vue')},
      { path: 'home', name: '主页', component: () => import('../views/Home.vue')},
      { path: 'questionbank', name: '个人试题库', component: () => import('../views/QuestionBank.vue')},
      { path: 'publicquestionbank', name: '公共试题库', component: () => import('../views/QuestionBankPublic.vue')},
      { path: 'teachingresources', name: '教学资源库', component: () => import('../views/ResourcesBank.vue')},
      { path: 'message', name: '消息', component: () => import('../views/TeacherMessage.vue')},
    ]
  },
  {
    path: '/',
    component: ()=>import('../views/ManageHeader.vue'),
    redirect:"/login",
    children:[
        { path: 'llmcheck', name: '智能批阅', component: () => import('../views/LlmPromptTeacher.vue')},
        { path: 'llmcheck_admin', name: '智能批阅管理', component: () => import('../views/LlmPromptManager.vue')},
      { path: 'course', name: '课程', component: () => import('../views/Course.vue')},
      {path: 'courseprompt', name:'课程专属提示词', component: () => import('../views/CoursePrompt.vue')},
      { path: 'teacherMindMap', name: '思维导图', component: () => import('../views/TeacherMindMap.vue')},
      { path: 'chatAgent', name: 'AI助手', component: () => import('../views/ChatAgent.vue')},
      { path: 'assignment', name: '作业', component: () => import('../views/Assignment.vue')},
        { path: 'assignment_item', name: '作业题目', component: () => import('../views/AssignmentItem.vue')},
      { path: 'checkassignment', name: '查看作业',  beforeRouteEnter: (to, from, next) => {
          // Retrieve pagination state when entering the page
          store.dispatch('updatePageInfo', {
            pageNum: store.state.pagination.pageNum,
            pageSize: store.state.pagination.pageSize,
          });
              store.dispatch('updateSortParams', {
                  sortField: store.state.sortParams.sortField,
                  sortOrder: store.state.sortParams.sortOrder,
              });
          next();
        },component: () => import('../views/CheckAssignment.vue')},
      { path: 'manage_stu', name: '课程管理',  beforeRouteEnter: (to, from, next) => {
          // Retrieve pagination state when entering the page
          store.dispatch('updatePageInfo', {
            pageNum: store.state.pagination.pageNum,
            pageSize: store.state.pagination.pageSize,
          });
          next();
        },component: () => import('../views/Manage_stu.vue')},
      { path: 'manage_ass', name: '作业库',  beforeRouteEnter: (to, from, next) => {
          // Retrieve pagination state when entering the page
          store.dispatch('updatePageInfo', {
            pageNum: store.state.pagination.pageNum,
            pageSize: store.state.pagination.pageSize,
          });
          next();
        },component: () => import('../views/Manage_ass.vue')},
        { path: 'ass_analysis', name: '班级学情分析',  beforeRouteEnter: (to, from, next) => {
          next();
        },component: () => import('../views/AssignmentAnalysis.vue')},
      { path: 'questioncreate', name: '创建题目', component: () => import('../views/QuestionCreate.vue')},
      { path: 'questionedit', name: '修改题目', component: () => import('../views/QuestionEdit.vue')},
      { path: 'student_grade', name: '学生成绩', component: () => import('../views/StudentGrade.vue')},
      { path: 'teacher_mark', name: '教师批阅', component: () => import('../views/TeacherMark.vue')},
      { path: 'view_answer', name: '查看学生作答视角', component: () => import('../views/TeacherSwitchViewAnswer.vue')},
      { path: 'view_grade', name: '查看学生成绩视角', component: () => import('../views/TeacherSwitchViewGrade.vue')},
      { path: 'teacher_create_assignment', name: '创建作业', component: () => import('../views/TeacherCreateAssignment.vue')},
      { path: 'assignment_detail', name: '作业详情统计', component: () => import('../views/AssignmentDetail.vue')},
      { path: 'no_submitted', name: '未提交学生', component: () => import('../views/NoSubmitted.vue')},
      { path: 'exam_answer', name: '考试作答', props: (route) => ({ query: route.query }),component: () => import('../views/StudentExamAns.vue')},
      { path: 'student_answer', name: '学生作答', props: (route) => ({ query: route.query }),component: () => import('../views/StudentAnswer.vue')}
    ]
  },
  {
    path: '/',
    component: ()=>import('../views/ManageStudent.vue'),
    redirect:"/login",
    children:[
      // { path: 'course', name: '课程', component: () => import('../views/Course.vue')},
      { path: 'student_home', name: '学生主页', component: () => import('../views/StudentHome.vue')}
    ]
  },
  {
    path: '/',
    component: ()=>import('../views/ManageStudentCourse.vue'),
    redirect:"/login",
    children:[
      // { path: 'course', name: '课程', component: () => import('../views/Course.vue')},
      { path: 'student_course', name: '学生课程', props: (route) => ({ query: route.query }),component: () => import('../views/StudentCourse.vue')},
      { path: 'student_exam', name: '学生考试', props: (route) => ({ query: route.query }),component: () => import('../views/StudentExam.vue')},
        { path: 'ai_chat', name: '智能问答', component: () => import('../views/AIChat.vue')},
        { path: 'student_mindmap', name: '知识图谱', props: (route) => ({ query: route.query }),component: () => import('../views/StudentMindMap.vue')},
        { path: 'student_pathlearn', name: '推荐路径', props: (route) => ({ query: route.query }),component: () => import('../views/StudentPathLearn.vue')},
        { path: 'learn_assistant', name: '学习助手', props: (route) => ({ query: route.query }),component: () => import('../views/LearnAssistant.vue')},
    ]
  },
  {
    path: '/',
    component: ()=>import('../views/ManageAdmin.vue'),
    redirect:"/login",
    children:[
      // { path: 'course', name: '课程', component: () => import('../views/Course.vue')},
      { path: 'admin_home',  beforeRouteEnter: (to, from, next) => {
          // Retrieve pagination state when entering the page
          store.dispatch('updatePageInfo', {
            pageNum: store.state.pagination.pageNum,
            pageSize: store.state.pagination.pageSize,
          });
          next();
        },name: '管理员首页', props: (route) => ({ query: route.query }),component: () => import('../views/AdminHome.vue')},
      { path: 'admin_check_schedule', beforeRouteEnter: (to, from, next) => {
          // Retrieve pagination state when entering the page
          store.dispatch('updatePageInfo', {
            pageNum: store.state.pagination.pageNum,
            pageSize: store.state.pagination.pageSize,
          });
          next();
        }, name: '排课情况', props: (route) => ({ query: route.query }),component: () => import('../views/AdminCheckSchedule.vue')},
      { path: 'admin_check_map', name: '课程知识图谱模板', component: () => import('../views/AdminCheckMap.vue')},
      { path: 'admin_teacher',  beforeRouteEnter: (to, from, next) => {
          // Retrieve pagination state when entering the page
          store.dispatch('updatePageInfo', {
            pageNum: store.state.pagination.pageNum,
            pageSize: store.state.pagination.pageSize,
          });
          next();
        },name: '教师管理', props: (route) => ({ query: route.query }),component: () => import('../views/AdminTeacher.vue')},
      { path: 'admin_student',  beforeRouteEnter: (to, from, next) => {
          // Retrieve pagination state when entering the page
          store.dispatch('updatePageInfo', {
            pageNum: store.state.pagination.pageNum,
            pageSize: store.state.pagination.pageSize,
          });
          next();
        },name: '学生管理', props: (route) => ({ query: route.query }),component: () => import('../views/AdminStudent.vue')},
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  // {
  //   path: '/checkassignment',
  //   name: '查看作业',
  //   // component: YourAssignmentComponent,
  //   beforeRouteEnter: (to, from, next) => {
  //     // Retrieve pagination state when entering the page
  //     store.dispatch('updatePageInfo', {
  //       pageNum: store.state.pagination.pageNum,
  //       pageSize: store.state.pagination.pageSize,
  //     });
  //     next();
  //   },
  // },
  // {
  //   path: '/admin_check_schedule',
  //   name: '排课情况',
  //   // component: YourAssignmentComponent,
  //   beforeRouteEnter: (to, from, next) => {
  //     // Retrieve pagination state when entering the page
  //     store.dispatch('updatePageInfo', {
  //       pageNum: store.state.pagination.pageNum,
  //       pageSize: store.state.pagination.pageSize,
  //     });
  //     next();
  //   },
  // },
  // {
  //   path: '/admin_home',
  //   name: '管理员首页',
  //   // component: YourAssignmentComponent,
  //   beforeRouteEnter: (to, from, next) => {
  //     // Retrieve pagination state when entering the page
  //     store.dispatch('updatePageInfo', {
  //       pageNum: store.state.pagination.pageNum,
  //       pageSize: store.state.pagination.pageSize,
  //     });
  //     next();
  //   },
  // },
  // {
  //   path: '/admin_teacher',
  //   name: '教师管理',
  //   // component: YourAssignmentComponent,
  //   beforeRouteEnter: (to, from, next) => {
  //     // Retrieve pagination state when entering the page
  //     store.dispatch('updatePageInfo', {
  //       pageNum: store.state.pagination.pageNum,
  //       pageSize: store.state.pagination.pageSize,
  //     });
  //     next();
  //   },
  // },
  // {
  //   path: '/admin_student',
  //   name: '学生管理',
  //   // component: YourAssignmentComponent,
  //   beforeRouteEnter: (to, from, next) => {
  //     // Retrieve pagination state when entering the page
  //     store.dispatch('updatePageInfo', {
  //       pageNum: store.state.pagination.pageNum,
  //       pageSize: store.state.pagination.pageSize,
  //     });
  //     next();
  //   },
  // },
  // {
  //   path: '/manage_stu',
  //   name: '课程管理',
  //   // component: YourAssignmentComponent,
  //   beforeRouteEnter: (to, from, next) => {
  //     // Retrieve pagination state when entering the page
  //     store.dispatch('updatePageInfo', {
  //       pageNum: store.state.pagination.pageNum,
  //       pageSize: store.state.pagination.pageSize,
  //     });
  //     next();
  //   },
  // },
  // {
  //   path: '/manage_ass',
  //   name: '作业库',
  //   // component: YourAssignmentComponent,
  //   beforeRouteEnter: (to, from, next) => {
  //     // Retrieve pagination state when entering the page
  //     store.dispatch('updatePageInfo', {
  //       pageNum: store.state.pagination.pageNum,
  //       pageSize: store.state.pagination.pageSize,
  //     });
  //     next();
  //   },
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
// 路由守卫
// router.beforeEach((to, from, next) => {
//   localStorage.setItem("currentPathName", to.name)  // 设置当前的路由名称，为了在Header组件中去使用
//   store.commit("setPath")  // 触发store的数据更新
//   next()  // 放行路由
// })
export default router
